import i18n from '@/i18n'

const Meta = {
  leftMenuCode: 'Bills',
  leftActiveIndex: '/orders'
}

const OrderDetailMeta = {
  ...Meta,
  title: i18n.t('orders.orderDetails'),
  backable: true
}

export default [
  {
    path: '/orders',
    meta: {
      ...Meta,
      title: i18n.t('menu.myOrder')
    },
    component: () => import('@/views/orders/index.vue')
  },
  {
    path: '/orders/orderDetail',
    meta: OrderDetailMeta,
    component: () => import('@/views/orders/orderDetail.vue')
  },
  {
    path: '/orders/dailyDetail',
    meta: OrderDetailMeta,
    component: () => import('@/views/orders/dailyDetail.vue')
  },
  {
    path: '/orders/unsubDetail',
    meta: {
      ...Meta,
      title: i18n.t('orders.unsubDetail'),
      backable: true
    },
    component: () => import('@/views/orders/unsubDetail.vue')
  }
]
